import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import CombiningAssistanceProgramsPage from "@/pages/tools/CombiningAssistancePrograms";

export const Route = createFileRoute("/tools/combining-assistance-programs")({
  head: () => seoHead("/tools/combining-assistance-programs"),
  component: CombiningAssistanceProgramsPage,
});
